<template>
  <div>
    <div v-for="item in detailResponses" :key="item.linkedId">
      <div class="schedule-list">
        <div class="list-header">
          <span class="business-type">业务类型：{{item.bussinessType}}</span>
            <span v-if="item.sealTime !== ''" class="ab-right green">已盖章</span>
            <span v-else class="ab-right orange">未盖章</span>
        </div>
        <div class="list-content">
          <div class="con">
            <span class="con-title">工单号：</span>
            <span class="con-status">{{item.linkedId}}</span>
          </div>
          <div class="con">
            <span class="con-title">签名时间：</span>
            <span class="con-status">{{item.signature_time}}</span>
          </div>
          <div v-if="item.sealTime !== ''" class="con">
            <span class="con-title">盖章时间：</span>
            <span class="con-status">{{item.sealTime}}</span>
          </div>
        </div>
        <div class="list-bottom">
          <button class="detail-bottom" @click="downContract(item.contract)">查看合同</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Notify, Tab, Tabs, Button } from 'vant'
// import { getScheduleListReq, getBizTokenReq, getEyeInfoReq } from '@/api/manage'
import { getAllContractReq } from '@/api/manage'

Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Button)
export default {
  data () {
    return {
      detailResponses: {}
    }
  },
  mounted () {
    this.getAllContract()
  },
  methods: {
    getAllContract () {
      const params = {
        token: this.$cookies.get('token'),
        openId: this.$cookies.get('openid')
      }
      getAllContractReq(params).then(response => {
        const res = response.data
        console.log(res)
        if (res.code === 200) {
          this.detailResponses = res.data
        }
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取业务列表失败' })
        })
    },
    downContract (url) {
      window.location.href = this.filePath + url
    }
  }
}
</script>

<style lang="less" scoped>
  .schedule-list:first-child {
    margin-top: 10px;
  }
  .schedule-list {
    background: #FFF;
    margin-bottom: 10px;
  }
  .list-header {
    position: relative;
    padding: 12px;
    font-size: 14px;
  }
  .list-content {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    font-size: 13px;
  }
  .list-content .con:first-child {
    padding-top: 12px;
  }
  .list-content .con {
    padding: 0 12px 12px 12px;
  }
  .business-type {
    font-weight: bold;
  }
  .ab-right {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .list-bottom {
    position: relative;
    height: 40px;
  }
  .list-bottom .detail-msg {
    position: absolute;
    top: 6px;
    right: 80px;
    font-size: 11px;
    padding: 5px;
    color: #707070;
    border: 1px solid #707070;
    border-radius: 5px;
    background: #FFF;
  }
  .list-bottom .detail-bottom {
    position: absolute;
    top: 6px;
    right: 9px;
    font-size: 11px;
    padding: 5px;
    color: #707070;
    border: 1px solid #707070;
    border-radius: 5px;
    background: #FFF;
  }
  .green {
    color: green;
  }
  .orange {
    color: orange;
  }
</style>
